import { chartColours } from "../../themes/colours";
import { gis2QueryUrl } from '../../utils/urls.js'

import { hsdsLayerDefsExperian } from './experian/hsdsLayerDefsExperian'
import loacLayerDef from './loac/layer-def.jsx'
import visitorAndSpendLayerDef from './visitor-and-spend/layer-def.jsx'
import travelTimeLayerDef from './travel-time/layer-def.jsx'

import catchmentAreaLayerDef from './catchment-area/layer-def.jsx'
import imdLayerDef from './imd/layer-def.jsx'
import {hsdsLayerDefsNonRetailPOI} from "./non-retail-poi/hsdsLayerDefsNonRetailPOI";

const landOwnershipLayerDef = {
  layer: {
    id: "land-ownership",
    type: "fill",
    paint: {
      "fill-color": chartColours.ldnDkPink,
      "fill-opacity": 0.7,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "land-ownership",
    type: "geojson",
    data: gis2QueryUrl("public_land_01", 3),
  },
  labels: {
    parent: "Land Ownership",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: true,
  category: "hsds",
  popupAttributes: ["pty_addr", "owner_upper"],
}

export const hsdsLayersBase = {
  "loac": loacLayerDef,
  "imd": imdLayerDef,
}

export const hsdsLayersPoly = {
  "land-ownership": landOwnershipLayerDef,
  "travel-time": travelTimeLayerDef,
}

export const hsdsLayersPoly2 = {
  "visitor-and-spend": visitorAndSpendLayerDef,
  "catchment-area": catchmentAreaLayerDef,
}

export const hsdsLayersPoint = {
  ...hsdsLayerDefsExperian,
  ...hsdsLayerDefsNonRetailPOI,
}